<div class="ion-margin-start">
  <h1>Monitoraggio</h1>

  <ion-note>
    Configura gli strumenti per il monitoraggio periodico del paziente dalle sezioni disponibili qua
    sotto
  </ion-note>
</div>

<ion-grid class="ion-margin-top" *ngIf="!currentShownConfigs">
  <ion-row>
    <ion-col class="c3-flex ion-align-items-center ion-justify-content-center">
      <ion-icon size="large" color="secondary" [src]="'information-outline' | getIcon"> </ion-icon>
    </ion-col>
  </ion-row>
  <ion-row>
    <ion-col class="c3-flex ion-align-items-center ion-justify-content-center">
      <p>In questa sezione non è presente alcuna configurazione disponibile</p>
    </ion-col>
  </ion-row>
</ion-grid>

<ion-grid class="ion-margin-top">
  <ion-row>
    <ion-col size="12" *ngIf="showConfig('telemonitoring')" id="anchor-telemonitoring">
      <c3-config-telemonitoring #configSection> </c3-config-telemonitoring>
    </ion-col>

    
    <ng-container
      *ngIf="contexts &&
          !(
            contexts.includes('diabetes1') ||
            contexts.includes('diabetes2') ||
            contexts.includes('gestational') ||
            contexts.includes('pneumo') ||
            contexts.includes('parki') ||
            contexts.includes('oncology')
          )
        "
    >
      <ion-col size="12" *ngIf="showConfig('reports')" id="anchor-reports">
        <c3-config-reports #configSection [context]="patientContext$ | async"> </c3-config-reports>
      </ion-col>
    </ng-container>
  </ion-row>
</ion-grid>
